import React from "react";
import ReactCalendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./calendar.css";

const keyFromDate = (date) =>
  `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;

export default function CustomCalendar({ value, onChange, orderDates, pendingDates, overdueDates }) {
  const pend = pendingDates || overdueDates;
  return (
    <div className="calendar-wrapper">
      <ReactCalendar
        onChange={onChange}
        value={value}
        locale="es-MX"
        // 👇 Clase por día (el rojo tiene prioridad)
        tileClassName={({ date, view }) => {
          if (view !== "month") return null;
          const key = keyFromDate(date);
          if (pend?.has(key)) return "day-has-pending";
          if (orderDates?.has(key)) return "day-has-orders";
          return null;
        }}
        // 👇 Puntito en el día (rojo si hay pendientes, verde si solo hay órdenes normales)
        tileContent={({ date, view }) => {
          if (view !== "month") return null;
          const key = keyFromDate(date);
          if (pend?.has(key)) return <div className="order-dot dot-pending" />;
          if (orderDates?.has(key)) return <div className="order-dot dot-ok" />;
          return null;
        }}
      />
    </div>
  );
}